import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface FetchContentGapReportBuilderStateI {
    isDocumentStreamingInProgress: boolean,
    isPublishButtonClicked: boolean,
    isTestButtonClicked: boolean,
    selectedQueryId: string,
    isDocumentEmpty: boolean
};

const initialState: FetchContentGapReportBuilderStateI = {
    isDocumentStreamingInProgress: false,
    isPublishButtonClicked: false,
    isTestButtonClicked: false,
    selectedQueryId: '',
    isDocumentEmpty: true
};

export const fetchContentGapReportBuilderSlice = createSlice({
    name: 'fetch-content-gap-report-builder',
    initialState,
    reducers: {
        setIsDocumentStreamingInProgress: (state, action: PayloadAction<boolean>) => {
            state.isDocumentStreamingInProgress = action.payload
        },
        setIsPublishButtonClicked: (state, action: PayloadAction<boolean>) => {
            state.isPublishButtonClicked = action.payload
        },
        setIsTestButtonClicked: (state, action: PayloadAction<boolean>) => {
            state.isTestButtonClicked = action.payload
        },
        setSelectedQueryId: (state, action: PayloadAction<string>) => {
            state.selectedQueryId = action.payload
        },
        setIsDocumentEmpty: (state, action: PayloadAction<boolean>) => {
            state.isDocumentEmpty = action.payload
        },
        clearFetchContentGapReportBuilderState: (state) => {
            state.isDocumentStreamingInProgress = false;
            state.isPublishButtonClicked = false;
            state.isTestButtonClicked = false;
            state.selectedQueryId = '';
            state.isDocumentEmpty = true
        }
    },
})

export const {
    setIsDocumentStreamingInProgress,
    setIsPublishButtonClicked,
    setIsTestButtonClicked,
    setSelectedQueryId,
    clearFetchContentGapReportBuilderState,
    setIsDocumentEmpty
} = fetchContentGapReportBuilderSlice.actions;

export default fetchContentGapReportBuilderSlice.reducer;